import { ele } from "cables-shared-client";
import api from "../../api.js";

export default class PageAdminMaintenance
{
    constructor(targetElement)
    {
        const now = new Date();
        targetElement.value = now.toISOString()
            .split("T")[0];
    }

    toggleMaintenance()
    {
        api.get("admin/togglemaintenance", () => { document.location.reload(); });
    }

    scheduleMaintenance()
    {
        api.post("admin/schedulemaintenance", {
            "date": ele.byId("maintenance-schedule-date").value,
            "time": ele.byId("maintenance-schedule-time").value
        }, () => { document.location.reload(); });
    }

    removeMaintenance()
    {
        api.post("admin/schedulemaintenance?remove=true", {}, () => { document.location.reload(); });
    }

    postAnnouncement()
    {
        api.post("admin/announcement", { "message": document.getElementById("announcement").value, "level": document.getElementById("annoucement_level").value }, () => { document.location.reload(); });
    }

    removeAnnouncement()
    {
        api.delete("admin/announcement", {}, () => { document.location.reload(); });
    }
}
